import { render, staticRenderFns } from "./recorde.vue?vue&type=template&id=67209da6&"
import script from "./recorde.vue?vue&type=script&lang=js&"
export * from "./recorde.vue?vue&type=script&lang=js&"
import style0 from "./recorde.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports